


  // Check if the current path is '/collections'
    if (window.location.pathname === '/collections/bridal') {
        // Redirect to the new destination
        window.location.href = 'https://jewelryfactory.jewelershowcase.com/browse/3c-collection/ever-and-ever-collection/';
    }

  if (window.location.pathname === '/collections/certified-mined-and-lab-diamonds') {
        // Redirect to the new destination
        window.location.href = 'https://jewelryfactory.jewelershowcase.com/browse/diamonds/';
    }

 if (window.location.pathname === '/collections/customize') {
        // Redirect to the new destination
        window.location.href = 'https://jewelryfactory.jewelershowcase.com/band-builder';
    }

if (window.location.pathname === '/collections/badges') {
        // Redirect to the new destination
        window.location.href = 'https://jewelryfactory-com.myshopify.com/collections/police-fire-dept-jewelry';
    }

document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.getElementById('collection-search-input');
    
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            var query = searchInput.value.toLowerCase();
            var products = document.querySelectorAll('#product-grid .grid__item');

            products.forEach(function(product) {
                var heading = product.querySelector('.card__heading');
                if (!heading) return;
                var productTitle = heading.innerText.toLowerCase();
                product.style.display = productTitle.includes(query) ? '' : 'none';
            });
        });
    }

  

});



  document.addEventListener("DOMContentLoaded", function() {
    var stateSearch = document.getElementById('state-search');
    var stateDropdown = document.getElementById('state-dropdown');
    var stateFilter = document.getElementById('state-filter');
    if (stateFilter) {
        var collectionHandle = stateFilter.getAttribute('data-collection-handle');
    }

    var states = [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
      "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
      "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
      "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska",
      "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina",
      "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
      "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
      "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ];

    function filterStates(query) {
      stateDropdown.innerHTML = '';
      var filteredStates = states.filter(function(state) {
        return state.toLowerCase().includes(query.toLowerCase());
      });
      filteredStates.forEach(function(state) {
        var div = document.createElement('div');
        div.textContent = state;
        div.style.padding = '8px';
        div.style.cursor = 'pointer';
        div.onclick = function() {
          stateSearch.value = state;
          stateDropdown.style.display = 'none';
          // Trigger the change event to filter products
          filterProductsByState(state);
        };
        stateDropdown.appendChild(div);
      });
    }

    function filterProductsByState(state) {
      if (state) {
       window.location.href = '/collections/' + collectionHandle + '?sort_by=manual&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.productstate=' + encodeURIComponent(state);
      } else {
        window.location.href = '/collections/' + collectionHandle;
      }
    }
    if (stateSearch) {
      stateSearch.addEventListener('input', function() {
      var query = stateSearch.value;
      if (query) {
        stateDropdown.style.display = 'block';
        filterStates(query);
      } else {
        stateDropdown.style.display = 'none';
      }
    });
    }

    document.addEventListener('click', function(event) {
      // if (!stateSearch.contains(event.target) && !stateDropdown.contains(event.target)) {
      //   stateDropdown.style.display = 'none';
      // }
    });
  });


document.addEventListener('DOMContentLoaded', function() {
    var selects = document.querySelectorAll('.select__select.select-for-custom ');
    
    // Check if there are more than one select elements
    if (selects.length > 0) {
        selects.forEach(function(select) {
            select.addEventListener('change', function() {
                var selectedValue = this.value;
                // Perform AJAX request to refresh the page
                var xhr = new XMLHttpRequest();
                xhr.open('GET', window.location.href, true);
              
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        window.location.reload();
                    }
                };
                xhr.send();
            });
        });
    }
});









// Function to handle click on dropdown buttons
function handleDropdownClick(event) {
event.preventDefault(); // Prevent default link behavior

const clickedButton = event.currentTarget;

// Remove 'active-link' class from all buttons within the same dropdown
clickedButton.closest('.dropdown').querySelectorAll('button').forEach(button => {
  button.classList.remove('active-link');
});

// Add 'active-link' class to the clicked button
clickedButton.classList.add('active-link');
}

// Add click event listener to all dropdown buttons
document.querySelectorAll('.dropdown button').forEach(button => {
button.addEventListener('click', handleDropdownClick);
});

// Check sessionStorage for active button ID on page load
window.addEventListener('DOMContentLoaded', function() {
document.querySelectorAll('.dropdown').forEach(dropdown => {
  const activeButtonId = sessionStorage.getItem(dropdown.id);
  if (activeButtonId) {
    // Remove 'active-link' class from all buttons within the specific dropdown
    dropdown.querySelectorAll('button').forEach(button => {
      button.classList.remove('active-link');
    });
    // Add 'active-link' class to the button stored in sessionStorage within the specific dropdown
    const storedButton = document.getElementById(activeButtonId);
    if (storedButton) {
      storedButton.classList.add('active-link');
    }
  }
});

// Get current URL
const currentUrl = window.location.href;
// Check if any dropdown button's child <a> tag href matches the current URL
document.querySelectorAll('.dropdown button a').forEach(link => {
  if (link.href === currentUrl) {
    // Add 'active-link' class to the parent button
    link.closest('button').classList.add('active-link');
  }
});
});


document.addEventListener('DOMContentLoaded', (event) => {
    // Select elements with data-display attribute and content menus
    const triggerElements = document.querySelectorAll('[data-display]');
    const contentMenus = document.querySelectorAll('.content-menu');

    // Function to hide the target element
    const hideTarget = (target) => {
        target.style.display = 'none';
    };

    // Function to show the target element
    const showTarget = (target) => {
        target.style.display = 'flex';
    };

    // Add event listeners to trigger elements
    triggerElements.forEach(triggerElement => {
        const targetSelector = `[data-hidden="${triggerElement.getAttribute('data-display')}"]`;
     
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
            triggerElement.addEventListener('mouseenter', () => hideTarget(targetElement));
            triggerElement.addEventListener('mouseleave', () => showTarget(targetElement));
        }
    });

    // Add event listeners to content menus
    contentMenus.forEach(contentMenu => {
        contentMenu.addEventListener('mouseenter', () => {
            triggerElements.forEach(triggerElement => {
                const targetSelector = `[data-hidden="${triggerElement.getAttribute('data-display')}"]`;
                const targetElement = document.querySelector(targetSelector);
                if (targetElement) {
                    hideTarget(targetElement);
                }
            });
        });

        contentMenu.addEventListener('mouseleave', () => {
            triggerElements.forEach(triggerElement => {
                const targetSelector = `[data-hidden="${triggerElement.getAttribute('data-display')}"]`;
                const targetElement = document.querySelector(targetSelector);
                if (targetElement) {
                    showTarget(targetElement);
                }
            });
        });
    });
});




document.addEventListener("DOMContentLoaded", function() {


const submenuLinks = document.querySelectorAll('[data-target]');

submenuLinks.forEach(function(link) {

  const targetId = link.getAttribute("data-target");

  const submenu = document.getElementById(targetId);
  link.addEventListener("mouseenter", function() {

    submenu.style.display = "flex";
  });

  link.addEventListener("mouseleave", function() {
 
    if (!submenu.matches(':hover')) {
      submenu.style.display = "none";
    }
  });

 
  submenu.addEventListener("mouseenter", function() {

    submenu.style.display = "flex";
  });

  submenu.addEventListener("mouseleave", function() {
 
    submenu.style.display = "none";
  });
});


  
});




   window.onload = function() {
        var anchors = document.getElementsByTagName("a");
        for (var i = 0; i < anchors.length; i++) {
            if (anchors[i].textContent.trim() === "EasyFlow Product Options") {
                var parentParagraph = anchors[i].parentNode;
                if (parentParagraph.tagName.toLowerCase() === 'p') {
                    parentParagraph.style.display = "none";
                }
            }
        }
    };

// document.addEventListener('DOMContentLoaded', function() {
//     document.querySelectorAll('.select-for-custom').forEach(function(select) {
//         var label = select.previousElementSibling; // Get the label element that is before the select
//         var currentLabelText = label.textContent.split(' - ')[0]; // Extract the static part (e.g., "Size")
        
//         // Update the label text when a selection is made
//         select.addEventListener('change', function() {
//             var selectedOption = select.options[select.selectedIndex]; // Get the selected option
//             // Update the label with the selected option text
//             label.textContent = `${currentLabelText} - ${selectedOption.textContent}`;
//         });
        
//         // Set the initial label text on page load
//         var initialSelectedOption = select.options[select.selectedIndex];
//         label.textContent = `${currentLabelText} - ${initialSelectedOption.textContent}`;
//     });
// });



document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.select-for-custom').forEach(function(select) {
        var numberOfOptions = select.children.length;

        // Hide the select element
        select.classList.add('s-hidden');

        // Wrap the select element in a div
        var wrapper = document.createElement('div');
        wrapper.classList.add('select');
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(select);

        // Insert a styled div to sit over the top of the hidden select element
        var styledSelect = document.createElement('div');
        styledSelect.classList.add('styledSelect');
        wrapper.appendChild(styledSelect);

        // Insert an unordered list after the styled div
        var list = document.createElement('ul');
        list.classList.add('options');
        wrapper.appendChild(list);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            var listItem = document.createElement('li');
            listItem.textContent = select.children[i].textContent;
            listItem.setAttribute('rel', select.children[i].value);
            list.appendChild(listItem);
        }

        // Cache the list items
        var listItems = list.querySelectorAll('li');

        // Set initial display text
        styledSelect.textContent = select.options[select.selectedIndex].textContent;

        // Show the unordered list when the styled div is clicked
        styledSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            document.querySelectorAll('div.styledSelect.active').forEach(function(activeSelect) {
                activeSelect.classList.remove('active');
                activeSelect.nextElementSibling.style.display = 'none';
            });
            styledSelect.classList.toggle('active');
            list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
            
            // Show the option values when the dropdown is active
            if (styledSelect.classList.contains('active')) {
                listItems.forEach(function(listItem) {
                    var textContent = listItem.textContent.trim();
                    var startIndex = textContent.indexOf('[');
                    var endIndex = textContent.lastIndexOf(']');
                    if (startIndex !== -1 && endIndex !== -1) {
                        listItem.textContent = textContent.substring(0, startIndex).trim() + textContent.substring(endIndex + 1).trim();
                    }
                });
            } else {
                listItems.forEach(function(listItem) {
                    listItem.textContent = listItem.textContent.trim();
                });
            }
        });

        // Hides the unordered list when a list item is clicked and updates the styled div
        listItems.forEach(function(listItem) {
            listItem.addEventListener('click', function(e) {
                e.stopPropagation();
                styledSelect.textContent = listItem.textContent;
                styledSelect.classList.remove('active');
                select.value = listItem.getAttribute('rel');
                
                // Update the selected attribute of options
                Array.from(select.options).forEach(option => {
                    option.selected = option.value === listItem.getAttribute('rel');
                });

                // Update selected attribute in the HTML
                select.setAttribute('value', select.value); // Update value attribute
                select.querySelectorAll('option').forEach(option => {
                    if (option.value === select.value) {
                        option.setAttribute('selected', 'selected');
                    } else {
                        option.removeAttribute('selected');
                    }
                });

                list.style.display = 'none';
                // Trigger change event for the original select element
                var event = new Event('change', { bubbles: true });
                select.dispatchEvent(event);
            });
        });

        // Hides the unordered list when clicking outside of it
        document.addEventListener('click', function() {
            styledSelect.classList.remove('active');
            list.style.display = 'none';
        });
    });
});






document.addEventListener('DOMContentLoaded', function () {
    const hoverItems = document.querySelectorAll('.submenu-link');

    hoverItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            hoverItems.forEach(el => {
                if (el !== item) {
                    el.classList.add('other-color');
                }
            });
        });

        item.addEventListener('mouseleave', () => {
            hoverItems.forEach(el => {
                el.classList.remove('other-color');
            });
        });
    });

  // document.querySelectorAll('.ef__product-option-input').forEach(function(checkbox) {
  //           checkbox.addEventListener('change', function() {
  //               // Remove the color-changed class from all elements
  //               document.querySelectorAll('.color-changed').forEach(function(el) {
  //                   el.classList.remove('color-changed');
  //               });

  //               // Add the color-changed class to the current checkbox's parent div
  //               if (this.checked) {
  //                   var parentDiv = this.closest('.ef__option-value.ef__option-value-image-swatch');
  //                   parentDiv.classList.add('color-changed');
  //               }
  //           });
  //       });

});


 document.addEventListener("DOMContentLoaded", function() {
    const liElements = document.querySelectorAll(".collection-list__item");

    liElements.forEach(li => {
      const link = li.querySelector(".full-unstyled-link");
      const href = link.getAttribute("href");

      const wrapper = document.createElement('a');
      wrapper.setAttribute('href', href);
      wrapper.classList.add('lielements');
      
      const cardWrapper = li.querySelector('.collection-card-wrapper');

      // Insert the wrapper before the cardWrapper
      li.insertBefore(wrapper, cardWrapper);
      
      // Move the cardWrapper inside the new wrapper
      wrapper.appendChild(cardWrapper);
    });
  });


 document.addEventListener("DOMContentLoaded", function() {

   document.querySelectorAll('.options li').forEach(function(li) {
    let relValue = li.getAttribute('rel');
    let img = document.createElement('img');

    if (relValue === 'Locket Bail Top') {
        li.classList.add('bail-top');
        img.src = 'https://cdn.shopify.com/s/files/1/0637/1082/2550/files/swacth-img2_256x256.png'; //e with a relevant description
    } else if (relValue === 'Classic soldered jump ring') {
        li.classList.add('classic');
        img.src = 'https://cdn.shopify.com/s/files/1/0637/1082/2550/files/Classic_Soldered_Jump_Ring_256x256.png'; // Replace with the actual image path for classic
        img.alt = 'Classic Image'; // Replace with a relevant description
    }

    if (relValue === 'Locket Bail Top' || relValue === 'Classic soldered jump ring') {
        li.appendChild(img);
    }
});

 });




  // document.addEventListener("DOMContentLoaded", function() {
  //       const rows = document.querySelectorAll("#table-body tr");
  //       const toggleButton = document.getElementById("toggle-button");

  //       // Initially show the first 6 rows
  //       for (let i = 0; i < 6; i++) {
  //         if (rows[i]) {
  //           rows[i].classList.add("visible");
  //         }
  //       }

  //       // Toggle function to show/hide rows
  //       window.toggleRows = function() {
  //         const visibleRows = document.querySelectorAll("#table-body tr.visible");
  //         if (visibleRows.length > 6) {
  //           // If more than 6 rows are visible, hide the extra ones
  //           for (let i = 6; i < rows.length; i++) {
  //             rows[i].classList.remove("visible");
  //           }
  //           toggleButton.textContent = "Read More";
  //         } else {
  //           // If only 6 rows are visible, show all rows
  //           for (let i = 6; i < rows.length; i++) {
  //             rows[i].classList.add("visible");
  //           }
  //           toggleButton.textContent = "Read Less";
  //         }
  //       };
  //     });
  

// $1000 minimum order offer

(function () {
  'use strict';

  const MINIMUM_CART_VALUE = 100000; // $1,000 in cents
  const FREE_PRODUCT_VARIANT = null;
  if (!FREE_PRODUCT_VARIANT) return;
  let updating = false;
  let checkTimeout = null;

  async function getCart() {

    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to get cart');
    }

    return await response.json();
  }


  async function addFreeProduct() {

    console.log(
      '[FREE PRODUCT] Adding free product:',
      FREE_PRODUCT_VARIANT
    );

    const response = await fetch('/cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: FREE_PRODUCT_VARIANT,
            quantity: 1
          }
        ]
      })
    });


    const data = await response.json();


    if (!response.ok) {

      console.error(
        '[FREE PRODUCT] Shopify error:',
        data
      );

      throw new Error(
        data.description ||
        data.message ||
        'Unable to add free product'
      );
    }


    console.log(
      '[FREE PRODUCT] Successfully added.'
    );


    return data;
  }

  async function removeFreeProduct(lineKey) {

    console.log(
      '[FREE PRODUCT] Removing:',
      lineKey
    );


    const response = await fetch('/cart/change.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });


    const data = await response.json();


    if (!response.ok) {

      throw new Error(
        data.description ||
        data.message ||
        'Unable to remove free product'
      );
    }


    console.log(
      '[FREE PRODUCT] Successfully removed.'
    );


    return data;
  }
  async function setFreeProductQuantity(lineKey) {

    const response = await fetch('/cart/change.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        id: lineKey,
        quantity: 1
      })
    });


    if (!response.ok) {

      const data = await response.json().catch(
        function () {
          return {};
        }
      );

      throw new Error(
        data.description ||
        data.message ||
        'Unable to update free product'
      );
    }


    return await response.json();
  }

  function getPaidCartValue(cart) {
    let paidValue = 0;

    cart.items.forEach(function (item) {

      if (
        Number(item.variant_id) ===
        Number(FREE_PRODUCT_VARIANT)
      ) {
        return;
      }

      paidValue += Number(
        item.final_line_price ??
        item.line_price ??
        0
      );

    });


    return paidValue;
  }

  function refreshCartPage() {

    if (
      window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart/')
    ) {

      window.location.reload();

      return;
    }

  }

  async function checkFreeProduct() {


    if (updating) {
      return;
    }


    updating = true;


    try {

      const cart = await getCart();

      const paidCartValue =
        getPaidCartValue(cart);

      const freeItems =
        cart.items.filter(function (item) {

          return (
            Number(item.variant_id) ===
            Number(FREE_PRODUCT_VARIANT)
          );

        });

      const qualifies =
        paidCartValue >= MINIMUM_CART_VALUE;


      console.log(
        '[FREE PRODUCT] Paid cart value: $' +
        (paidCartValue / 100).toFixed(2)
      );


      console.log(
        '[FREE PRODUCT] Qualifies:',
        qualifies
      );

      if (
        qualifies &&
        freeItems.length === 0
      ) {

        console.log(
          '[FREE PRODUCT] $1,000 reached. Adding product...'
        );


        await addFreeProduct();

        await new Promise(function (resolve) {

          setTimeout(resolve, 300);

        });

        refreshCartPage();


        return;
      }


      if (
        !qualifies &&
        freeItems.length > 0
      ) {

        console.log(
          '[FREE PRODUCT] Cart below $1,000. Removing product...'
        );


        for (
          const item of freeItems
        ) {

          await removeFreeProduct(
            item.key
          );

        }


        await new Promise(function (resolve) {

          setTimeout(resolve, 300);

        });


        refreshCartPage();


        return;
      }

      if (
        qualifies &&
        freeItems.length > 0
      ) {

        if (
          Number(freeItems[0].quantity) !== 1
        ) {

          console.log(
            '[FREE PRODUCT] Resetting quantity to 1.'
          );


          await setFreeProductQuantity(
            freeItems[0].key
          );

        }

        if (
          freeItems.length > 1
        ) {

          console.log(
            '[FREE PRODUCT] Removing duplicate free products.'
          );


          for (
            let i = 1;
            i < freeItems.length;
            i++
          ) {

            await removeFreeProduct(
              freeItems[i].key
            );

          }


          refreshCartPage();
        }
      }


    } catch (error) {

      console.error(
        '[FREE PRODUCT] ERROR:',
        error
      );

    } finally {

      updating = false;
    }
  }

  function scheduleCheck(delay) {

    clearTimeout(checkTimeout);


    checkTimeout = setTimeout(
      function () {

        checkFreeProduct();

      },
      delay || 500
    );
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        scheduleCheck(500);

      }
    );

  } else {

    scheduleCheck(500);
  }

  const originalFetch =
    window.fetch;


  window.fetch = function () {

    const args = arguments;

    const request =
      args[0];


    return originalFetch
      .apply(this, args)
      .then(function (response) {


        try {

          const url =
            typeof request === 'string'
              ? request
              : (
                  request &&
                  request.url
                    ? request.url
                    : ''
                );


          if (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear')
          ) {

            scheduleCheck(700);
          }


        } catch (error) {

          console.error(
            '[FREE PRODUCT] Fetch watcher error:',
            error
          );

        }


        return response;
      });
  };

  const originalOpen =
    XMLHttpRequest.prototype.open;


  XMLHttpRequest.prototype.open =
    function (method, url) {

      this._freeProductURL =
        typeof url === 'string'
          ? url
          : '';


      return originalOpen.apply(
        this,
        arguments
      );
    };


  const originalSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.send =
    function () {

      this.addEventListener(
        'load',
        function () {

          try {

            const url =
              this._freeProductURL || '';


            if (
              url.includes('/cart/add') ||
              url.includes('/cart/change') ||
              url.includes('/cart/update') ||
              url.includes('/cart/clear')
            ) {

              scheduleCheck(700);
            }

          } catch (error) {

            console.error(
              '[FREE PRODUCT] XHR watcher error:',
              error
            );
          }

        }
      );


      return originalSend.apply(
        this,
        arguments
      );
    };

  document.addEventListener(
    'cart:updated',
    function () {

      scheduleCheck(500);

    }
  );


  document.addEventListener(
    'cart:refresh',
    function () {

      scheduleCheck(500);

    }
  );


})();
 
